import ObjectModelPermission from "~/models/objectModelPermissions/objectModelPermission";
import ObjectModel from "~/models/objectModel";
import {
  IObjectModelPermissionConstructorOptions,
  IObjectModelPermissionConstructorOptionsWCheck,
  ObjectModelPermissionPermittableType
} from "~/interfaces/objectModelInterfaces"
import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
import ObjectModelActionPermission from "~/models/objectModelPermissions/objectModelActionPermission";
import ObjectModelPropertyPermission from "~/models/objectModelPermissions/objectModelPropertyPermission";
import assertNever from "../../../global/assetNever";
import {InstanceHelper} from "~/helpers/instanceHelper";
import {ObjectModelPermissionDefinition} from '~/models/objectModels/objectModelPermissionDefinition'
import {IPermittee} from '~/interfaces/permitteeInterfaces'
import ObjectModelRelationshipPermission from "~/models/objectModelPermissions/objectModelRelationshipPermission";

export default class ObjectModelPermissionFactory {
  /**
   * @return {ObjectModelPermission, null} null is possible if trying to create a permission that is not allowed
   */
  static create(parent: ObjectModel, options: IObjectModelPermissionConstructorOptions | IObjectModelPermissionConstructorOptionsWCheck = {
    permissionType: null,
    json: {},
    skipCreateCheck: false,
  }): ObjectModelPermission | null {
    options.json = options.json || {};
    let permission: ObjectModelPermission = null;
    if (options.skipCreateCheck || 'permittee' in options && 'permittable' in options && ObjectModelPermissionDefinition.canCreate(options)) {
      switch (options.permissionType) {
        case ObjectModelPermissionType.Action:
          permission = new ObjectModelActionPermission(parent, options);
          break;
        case ObjectModelPermissionType.Property:
          permission = new ObjectModelPropertyPermission(parent, options);
          break;
        case ObjectModelPermissionType.Relationship:
          permission = new ObjectModelRelationshipPermission(parent, options);
          break;
        default:
          assertNever(options.permissionType);
      }
    }

    return permission;
  }

  // LANE: Abstract out to common location.
  /**
   * @return {ObjectModelPermission, null} null is possible if trying to create a permission that is not allowed
   */
  static findOrCreate(idsToCheck: string | string[], objectModel: ObjectModel, permissionType: ObjectModelPermissionType, json: object = {}, options: { skipCreateCheck: true } | { skipCreateCheck: false | undefined, permittee: IPermittee, permittable: ObjectModelPermissionPermittableType } = {
      skipCreateCheck: false,
      permittee: null,
      permittable: null,
    }): ObjectModelPermission | null {
    let permission: ObjectModelPermission = null;
    for (const id of InstanceHelper.toArray(idsToCheck)) {
      permission = ObjectModelPermission.repo.find(id)
      if (permission) return permission;
    }
    return ObjectModelPermissionFactory.create(objectModel, { permissionType, json, ...options });
  }
}